// Forms that the browser submits itself opt into FcCore::SignupBotChecker with
// `data-bot-check="<purpose>"` and a `bot_check_token` hidden field.
import DomLoaded from "utils/dom-loaded"
import { attachBotCheckToForm } from "utils/signup-bot-check"

DomLoaded(() => {
  document.querySelectorAll("form[data-bot-check]").forEach((form) => {
    attachBotCheckToForm(form, form.dataset.botCheck || undefined)
  })
})
